<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-custom">
  <!-- Because the integer field is essentially text, we can render it with the *scText helper -->
  <span *scText="rendering.fields.customIntField"></span>
</app-styleguide-specimen>
